import { render } from "./InstanceView.vue?vue&type=template&id=6a36f9f0&scoped=true"
import script from "./InstanceView.vue?vue&type=script&lang=js"
export * from "./InstanceView.vue?vue&type=script&lang=js"

import "./InstanceView.vue?vue&type=style&index=0&id=6a36f9f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a36f9f0"]])

export default __exports__